/**
 * Global react-pdf configuration. Import this once (e.g. from the document
 * generation screen) so settings are applied before any PDF is rendered.
 */
import { Font } from '@react-pdf/renderer'

/** Disable react-pdf's default word hyphenation across all documents. */
Font.registerHyphenationCallback((word) => [word])
